import { AiOutlineArrowRight } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

function CardPorto() {
  const navigate = useNavigate();
  const data = useSelector((state) => state.data);
  const datas = data.datas;
  // Mengecek Kondisi apakah bilangan ganjil atau genap
  const evenArr = (value) => {
    return Math.abs(value % 2) === 0;
  };

  let location = useLocation();
  console.log(location);

  return (
    <>
      {datas?.map((el, idx) => {
        return evenArr(2) === (idx % 2 === 0) ? (
          <div className="p-2" key={idx}>
            <div className="mt-20 max-w-md m-auto md:max-w-3xl lg:max-w-5xl md:flex rounded-lg bg-white border-4 shadow-xl border-gray-700]">
              <div className="flex items-center justify-center max-w-lg m-4 overflow-hidden rounded-md md:max-w-5xl">
                <img src={el.image} className="z-0 block w-full transition-all hover:scale-x-105 hover:scale-y-105" alt="" />
              </div>
              <div className="flex flex-col items-start justify-center max-w-md px-4 mx-auto mt-8">
                <span className="font-bold text-green-600">{el.category}</span>
                <h1 className="mt-3 text-4xl font-bold">{el.title}</h1>
                <p className="text-gray-400 mt-7">{el.desc}</p>
                <div
                  className="my-8 text-[#2A7CAB] font-bold flex items-center cursor-pointer"
                  onClick={() => {
                    navigate(`/project/${el.link}`);
                  }}
                >
                  Lihat Detail
                  <span className="px-3">
                    <AiOutlineArrowRight />
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="p-2" key={idx}>
            <div className="max-w-md m-auto mt-20 bg-white border-4 rounded-lg shadow-xl md:max-w-3xl lg:max-w-5xl md:flex md:flex-row-reverse border-700">
              <div className="flex items-center justify-center max-w-lg m-4 overflow-hidden rounded-md md:max-w-5xl">
                <img src={el.image} className="block w-full transition-all hover:scale-x-105 hover:scale-y-105" alt="" />
              </div>
              <div className="flex flex-col items-start justify-center max-w-md px-4 mx-auto mt-8">
                <span className="font-bold text-green-600">{el.category}</span>
                <h1 className="mt-3 text-4xl font-bold">{el.title}</h1>
                <p className="text-gray-400 mt-7">{el.desc}</p>
                <div
                  className="my-8 text-[#2A7CAB] font-bold flex items-center cursor-pointer"
                  onClick={() => {
                    navigate(`/project/${el.link}`);
                  }}
                >
                  Lihat Detail
                  <span className="px-3">
                    <AiOutlineArrowRight />
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default CardPorto;
